import { render, staticRenderFns } from "./chemReviewComponents.vue?vue&type=template&id=6f42746f"
import script from "./chemReviewComponents.vue?vue&type=script&lang=js"
export * from "./chemReviewComponents.vue?vue&type=script&lang=js"
import style0 from "./chemReviewComponents.vue?vue&type=style&index=0&id=6f42746f&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f42746f')) {
      api.createRecord('6f42746f', component.options)
    } else {
      api.reload('6f42746f', component.options)
    }
    module.hot.accept("./chemReviewComponents.vue?vue&type=template&id=6f42746f", function () {
      api.rerender('6f42746f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/chemReviewComponents.vue"
export default component.exports